import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const getFarmersList = createAsyncThunk("getFarmersList", async () => {
  const token = localStorage.getItem("cu_user")
  try {

    const { data } = await axios.get(
      `${process.env.REACT_APP_API_HOST}/api/farmer`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    return data.data;
  } catch (error) {
    console.error(error);
  }
});

export const FarmerSlice = createSlice({
  name: "farmers",
  initialState: {
    farmersList: [],
    status: "idle",
  },
  reducers: {},
  extraReducers: {
    [getFarmersList.pending]: (state) => {

      state.status = "pending";
    },
    [getFarmersList.fulfilled]: (state, action) => {

      state.status = "success";
      state.farmersList = action.payload;
    },
    [getFarmersList.rejected]: (state, action) => {
      state.status = "failed";
    },
  },
});

export default FarmerSlice.reducer;
